const CREDITS_UPDATED_EVENT = 'credits-updated';

export function isValidServerBalance(balance: unknown): balance is number {
  return typeof balance === 'number' && Number.isFinite(balance) && balance >= 0;
}

/** Browser-only: dispatch one credits-updated event with a verified balance. */
export function applyServerBalance(balance: unknown): boolean {
  if (typeof window === 'undefined') return false;
  if (!isValidServerBalance(balance)) return false;

  window.dispatchEvent(new CustomEvent(CREDITS_UPDATED_EVENT, { detail: { balance } }));
  return true;
}

let refreshDebounceTimer: ReturnType<typeof setTimeout> | null = null;
let pendingRefresh: (() => Promise<void>) | null = null;

/** Debounced refresh to avoid duplicate /api/stripe/subscription calls per action. */
export function scheduleSubscriptionRefresh(
  refreshSubscription: () => Promise<void>,
  delayMs = 300
): void {
  if (typeof window === 'undefined') return;

  pendingRefresh = refreshSubscription;
  if (refreshDebounceTimer) {
    clearTimeout(refreshDebounceTimer);
  }

  refreshDebounceTimer = setTimeout(() => {
    refreshDebounceTimer = null;
    const refresh = pendingRefresh;
    pendingRefresh = null;
    void refresh?.();
  }, delayMs);
}

/** Prefer server-returned balance; fall back to a single debounced refresh. */
export function applyBalanceOrRefresh(
  balance: unknown,
  refreshSubscription: () => Promise<void>
): void {
  if (!applyServerBalance(balance)) {
    scheduleSubscriptionRefresh(refreshSubscription);
  }
}
